<template>
  <b-modal
  hide-footer
    @shown="openForm"
    dialog-class="dialog-class"
    v-model="isShow"
    @hidden="$emit('update:isShow', false)"
    centered
    size="md"
  >
    <template #modal-header>
      <h4 class="mb-0 text-primary">
        {{ $t("ar_client_account_transaction_history") }} {{ accountCode }}
      </h4>
      <div class="d-flex align-items-center">
        <ez-icon
          icon="ezAr-icon-x"
          class="cursor-pointer"
          size="24"
          color="#114A9F"
          @click="$emit('update:isShow', false)"
        />
      </div>
    </template>
    <SectionTransformTable>
      <div class="d-flex p-2 align-items-center">
        <div
          class="outline-none d-flex"
          tabindex="0"
          @keyup.enter="refetchData"
          style="width: 70%; margin-right: 40px"
        >
          <div class="d-flex w-38 flex-column mr-5">
            <label class="mb-1"> Nội dung tìm kiếm </label>

            <WidgetString
             
           
              placeholder="Nội dung tìm kiếm"
           
              v-model="searchVal.text"
            />
          </div>

          <div class="d-flex w-50 flex-column">
            <label class="mb-1"> Ngày giao dịch</label>

            <WidgetDateTime
            :clearable="true"
        :isRange="true"
        v-model="searchVal.transactionDate"
        placeholder="Ngày giao dịch"

      />  
          </div>
        </div>

        <div style="width: 30%; padding-left: 20px;margin-top: 30px;">
          <b-button  variant="primary" @click="refetchData">
            <ez-icon icon="ezAr-icon-search" style="margin-right: 3px" />{{
              $t("ar_common_search")
            }}</b-button
          >
        </div>
      </div>
      <div class="divider"></div>
      <div class="px-1">

        <EzTable
        :toolbar-config="{disableColumnChooser:true}"
        :excelExportParams="{FromDate:searchVal.transactionDate?.startDate,ToDate:dayjs(searchVal.transactionDate?.endDate).add('1','day'),ArAccountId:id}"
        excel-export-api-code="AR_HSAA03"  
        :excelExport="arClient.api_ExcelAR_HSAA01"
          :dataSourceParams="{ Text:searchVal.text, ArAccountId: id,FromDate:searchVal.transactionDate?.startDate,ToDate:dayjs(searchVal.transactionDate?.endDate).add('1','day') }"
          ref="tableRef"
          :columns="columns"
          :dataSource="arClient.api_AR_HSAA01"
        >
        <template #beforeToolbarActions>
          <div class="d-flex">
            <div class="d-flex align-items-center mr-3">
              <span class=" mr-1">Số dư đầu kỳ (VND):</span>
              <span class="font-weight-bolder text-primary"> {{ openingBalance }}</span>
             
            </div>
            <div class="d-flex align-items-center">
              <span class=" mr-1">Số dư cuối kỳ (VND):</span>
              <span class="font-weight-bolder text-primary">{{ lastSurplus }}</span>
    
            </div>
          </div>
        </template>
      </EzTable>
      </div>
    </SectionTransformTable>
    
  </b-modal>
</template>
<style scoped lang="scss">
 .divider {
                background: rgba(193, 193, 193, 0.12);
                height: 12px;
            }
::v-deep .dialog-class {
  max-width: 900px !important;
}
</style>

<script>
import { defineComponent, ref, getCurrentInstance ,computed} from "@vue/composition-api";
import FormItems from "../../ultils/Form/FormItems.vue";

import { arClient } from "@/api/ar-client";

import SearchList from "../../ultils/SearchList/SearchList.vue";
import SectionTransformTable from "../../ultils/Section/SectionTransformTable.vue";
import EzTable from "../../ultils/Table/EzTable.vue";

import { useFetch } from "../../ultils/Hooks/useFetch.ts";
import { convertCommonActiveStatus } from "../../ultils/status";
import WidgetString from "../../ultils/Form/components/String/WidgetString.vue";
import WidgetDateTime from "../../ultils/Form/components/DateTime/WidgetDatetime.vue";

export default defineComponent({
  name: "AccountTransaction",
  components: {
    FormItems,
    SearchList,
    SectionTransformTable,
    EzTable,
    WidgetString,
    WidgetDateTime
},
  props: {
    id: String,
    accountCode: String,
    isShow: Boolean,
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;
    const tableRef = ref();
    const openingBalance = computed(()=>vm.formatPrice(tableRef?.value?.dataResponse?.OpeningBalance))
    const lastSurplus = computed(()=>vm.formatPrice(tableRef?.value?.dataResponse?.LastSurplus))

    const isShowSidebar = ref(false);
    const isShowForm = ref(false);

    const searchVal = ref({
      
      text:""
    });
    const { data: detailHistory, fetchData: fetchDetailHistory } = useFetch(arClient.api_AR_RPE02, {
      nextFunction() {
        isShowSidebar.value = true;
      },
    });
    const refetchData = () => {
      tableRef.value.fetchData();
    };
    const formItems = ref([
      {
        type: "string",
        name: "Keyword",

        label: "ar_client_search_content",
        wrapperClass: "col-3",
      },

      {
        type: "date",
        rangeData: ["FromDate", "ToDate"],
        name: "createdDate",
        isRange: true,
        placeholder: "ar_common_range",
        label: "ar_common_range",
        wrapperClass: "col-5",
      },
    ]);

    const columns = ref([
      {
        caption: "ar_client_transaction_date",
        field: "TransactionDate",
        cellTemplate:true,
        width:"110px",
        formatType:"date"
      },
      {
        caption: "ar_client_debt_incurred",
        cellTemplate:true,
       formatType:"num",

        width:"100px",
        field: "DebtIncurred",
      },
      {
        caption: "ar_client_have_incurred",
        cellTemplate:true,
       formatType:"num",
        width:"100px",
       
        field: "Incurred",
      },
      {
        caption: "ar_client_account_number_surplus",
        cellTemplate:true,
       formatType:"num",
        width:"100px",
       
        field: "Surplus",
      },
      {
        caption: "ar_client_content",
        field: "Note",
      
       
      },
    ]);

  
    const openForm = () => {};

    return {
      openForm,
      openingBalance,
      lastSurplus,
      columns,
      formItems,
      searchVal,
      tableRef,
      refetchData,
      isShowSidebar,
      isShowForm,
      detailHistory,
    };
  },
});
</script>
